//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
  name: 'article_2',
  data () {
    return {
      msg: ''
    }
  },
  created () {
      window.scrollTo(0,0)
  }
}



// WEBPACK FOOTER //
// ./src/components/article/article_2.vue